// src/App.js
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline, Container } from "@mui/material";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useThemeMode } from "./hooks/useThemeMode";
import { AuthProvider } from "./config/authContext";
import CreateMeeting from "./pages/CreateMeeting";
import RegisterAttendance from "./pages/RegisterAttendance";
import AttendanceReport from "./pages/AttendanceReport";
import MeetingList from "./pages/MeetingList";
import CalendarMeeting from "./pages/Calendar";
import DocumentsMeeting from "./pages/DocumentsMeeting";
import AppBar from "./components/AppBar";
import SplashScreen from "./components/SplashScreen";

function App() {
  const [showSplash, setShowSplash] = useState(true);
  const { theme, toggleTheme, isDarkMode, isLoading } = useThemeMode();

  // Ambil Google Client ID dari environment variable
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  if (isLoading) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          Loading...
        </div>
      </ThemeProvider>
    );
  }

  if (showSplash) {
    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SplashScreen onFinish={() => setShowSplash(false)} />
      </ThemeProvider>
    );
  }

  // Jika tidak ada Google Client ID, tetap tampilkan aplikasi tanpa fitur Google Drive
  if (!googleClientId) {
    console.warn(
      "REACT_APP_GOOGLE_CLIENT_ID tidak ditemukan. Fitur Google Drive tidak tersedia.",
    );
  }

  return (
    <GoogleOAuthProvider
      clientId={googleClientId || ""}
      onScriptLoadError={() => {
        console.error("Google OAuth script gagal dimuat");
      }}
    >
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <BrowserRouter>
            <AppBar toggleTheme={toggleTheme} isDarkMode={isDarkMode} />
            <Container maxWidth="md" sx={{ py: 4 }}>
              <Routes>
                <Route path="/" element={<MeetingList />} />
                <Route path="/meetings" element={<CreateMeeting />} />
                <Route
                  path="/register/:meetingId"
                  element={<RegisterAttendance />}
                />
                <Route
                  path="/report/:meetingId"
                  element={<AttendanceReport />}
                />
                <Route path="/calendar" element={<CalendarMeeting />} />
                <Route path="/documents" element={<DocumentsMeeting />} />
              </Routes>
            </Container>
          </BrowserRouter>
        </ThemeProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
